import axios from 'axios';
import { companyStore } from '../features/Company';
import { GET_ROUTE_LIST_BY_RESELLER } from '../constants/constants';

axios.defaults.validateStatus = () => {
	return true;
};

const isCompanyId = (companyId, endpoint) => {
	return companyId && GET_ROUTE_LIST_BY_RESELLER?.find((route) => endpoint?.includes(route));
};

function buildHeaders(isFormData, customHeaders = {}) {
	return {
		...(isFormData ? { 'Content-Type': 'multipart/form-data' } : { 'Content-Type': 'application/json' }),
		Accept: '*/*',
		'Access-Control-Allow-Origin': '*',
		...customHeaders,
	};
}

const fetchPostRequest = async (endpoint, data, isFormData, customHeaders = {}) => {
	const companyId = companyStore.selectedCompanyId;
	const { data: responseData } = await axios.post(endpoint, data, {
		params: isCompanyId(companyId, endpoint)
			? {
					companyId,
				}
			: {},
		headers: buildHeaders(isFormData, customHeaders),
		withCredentials: true,
	});
	return responseData;
};

const fetchPutRequest = async (endpoint, data, isFormData, customHeaders = {}) => {
	const companyId = companyStore.selectedCompanyId;
	const { data: responseData } = await axios.put(endpoint, data, {
		params: isCompanyId(companyId, endpoint)
			? {
					companyId,
				}
			: {},
		headers: buildHeaders(isFormData, customHeaders),
		withCredentials: true,
	});
	return responseData;
};

const fetchPatchRequest = async (endpoint, data, isFormData, customHeaders = {}) => {
	const companyId = companyStore.selectedCompanyId;
	const { data: responseData } = await axios.patch(endpoint, data, {
		params: isCompanyId(companyId, endpoint)
			? {
					companyId,
				}
			: {},
		headers: buildHeaders(isFormData, customHeaders),
		withCredentials: true,
	});
	return responseData;
};

const fetchDeleteRequest = async (endpoint, data, _, customHeaders = {}) => {
	const companyId = companyStore.selectedCompanyId;
	const { data: responseData } = await axios.delete(endpoint, {
		data: data,
		params: isCompanyId(companyId, endpoint)
			? {
					companyId,
				}
			: {},
		headers: buildHeaders(false, customHeaders),
		withCredentials: true,
	});
	return responseData;
};

const fetchGetRequest = async (endpoint, _data, _, customHeaders = {}) => {
	const companyId = companyStore.selectedCompanyId;
	const { data: responseData } = await axios.get(endpoint, {
		params: isCompanyId(companyId, endpoint)
			? {
					companyId,
				}
			: {},
		headers: buildHeaders(false, customHeaders),
		withCredentials: true,
	});
	return responseData;
};

const fetchApi = {
	get: fetchGetRequest,
	post: fetchPostRequest,
	put: fetchPutRequest,
	patch: fetchPatchRequest,
	delete: fetchDeleteRequest,
};

export default fetchApi;
